import React from 'react';

import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';

import amber from '@material-ui/core/colors/amber';

const styles = theme => ({
  selected: {
    color: amber[500],
    borderStyle: 'solid',
    borderBottomWidth: 'medium',
  },
  unselected: {

  }
});

const FilterButton = ({ classes, children, selected, onClick }) =>
  <Button
    className={selected ? classes.selected : classes.unselected}
    onClick={onClick}
    >
    {children}
  </Button>

export default withStyles(styles)(FilterButton);



// WEBPACK FOOTER //
// ./src/components/core/Filter/FilterButton.jsx